export default {
  sections: {
    setup_fee: {
      title: 'Costes de configuración',
      description: 'Costes de configuración desde {{amount}} – en lugar de 1.000+',
    },
  },
  labels: {
    month: 'Mes (NETO)',
    one_time_fee: 'Pago único',
    more_options: 'Más opciones',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Tu propia app en App Store y Google Play',
    push_notifications: 'Notificaciones push para ofertas',
    loyalty: 'Fidelización mediante programas de lealtad',
    offline_orders: 'Pedidos sin conexión disponibles',
    individual_design: 'Diseño de app personalizado',
  },
  setup_fee_options: {
    150: 'Configuración estándar',
    75: 'Reducido',
    0: 'Sin costes de creación',
  },
  feedback: {
    contract_signed_already: {
      title: 'El contrato ya está firmado',
      description: 'Contacte con soporte técnico si necesita hacer cambios',
    },
  },
};
